import { Flex, Skeleton } from "antd";
import React from "react";
import { SingleOrderContextProvider } from "../../organisms";
import { SupportedControls } from "..";
import { useIsMobile } from "../../../hooks/useIsMobile";

export const GlobalActions: React.FC<{ total: any; global_actions: any }> = ({
  global_actions,
}) => {
  const isMobile = useIsMobile();

  return global_actions ? (
    // Left-aligned and nowrap on mobile so the parent can scroll horizontally.
    <Flex justify={isMobile ? "start" : "end"} gap={8} align="center" wrap="nowrap">
      <SingleOrderContextProvider disableReadMode={false} global_actions={true}>
        {global_actions?.map((control: any) => {
          if (
            control.field_type === "redirect" ||
            control.field_type === "form-modal"
          ) {
            return <SupportedControls control={control} key={control.uuid} />;
          }
        })}
      </SingleOrderContextProvider>
    </Flex>
  ) : (
    <Flex justify="end" gap={16}>
      <Skeleton.Input active size="default" />
      <Skeleton.Input active size="default" />
    </Flex>
  );
};
